#import "@/components/common/RoutinePreviewFragment.gql"

fragment RoutineCardsSliderFragment on routineCardsSlider_Entry {
  id
  typeHandle
  heading
  backgroundGray
  ctaEntry {
    uri
    ... on exercisesPage_Entry {
      uri
      pageProfile
    }
  }
  ctaText
  routines {
    ...RoutinePreviewFragment
  }
}
